import Button from "@app/components/button";
import Input from "@app/components/input";
import { Z_INDECES } from "@app/constants/default";
import { isEmpty } from "lodash";
import Image from "next/image";
import { useState } from "react";

type Prop = {
  onClose: () => void;
  onProceed: () => void;
};
const PartnersLandingSectionPromptModal = ({ onClose, onProceed }: Prop) => {
  const [typedOption, setTypedOption] = useState<string>("");
  const [selectedOption, setSelectedOption] = useState<string>("");

  const isChecked = (option: string) => selectedOption === option;

  const positions = [
    "Club Manager",
    "General Manager",
    "Executive Chef",
    "Superintendent",
    "CFO",
  ];
  return (
    <div
      style={{ zIndex: Z_INDECES.MODAL }}
      className="rounded-xl flex flex-col space-y-5 p-6 bg-light w-[95vw] xs:w-[80vw] sm:w-[480px] 
      text-text-color-high-em"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex justify-center">
        <Image src="/assets/svgs/global/logo-mark.svg" width={143} height={24} alt="logo" />
      </div>
      <span className="subheading">Select Option:</span>
      <div className="flex flex-col space-y-2">
        {positions.map((position) => (
          <span key={position} className="flex space-x-2">
            <input
              type="radio"
              className="text-secondary focus:ring-secondary"
              style={{ backgroundImage: "none" }}
              checked={isChecked(position)}
              onChange={() => setSelectedOption(position)}
            />
            <span className="text-body-md">{position}</span>
          </span>
        ))}
        <div className="flex space-x-2">
          <input
            className="mt-1 text-secondary focus:ring-secondary"
            type="radio"
            style={{ backgroundImage: "none" }}
            checked={isChecked("others")}
            onChange={() => setSelectedOption("others")}
          />
          <Input
            value={isChecked("others") ? typedOption : ""}
            onChange={(e) => setTypedOption(e.target.value)}
            onClick={() => setSelectedOption("others")}
          />
        </div>
      </div>
      <div className="pt-10 flex space-x-3">
        <Button buttonType="base" size="sm" full onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="sm"
          full
          onClick={onProceed}
          disabled={
            isEmpty(selectedOption) ||
            (selectedOption === "others" && isEmpty(typedOption))
          }
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default PartnersLandingSectionPromptModal;
